/**
 * @fileoverview Header component displaying the Rithmo branding.
 *
 * @module components/Header
 */

import React from 'react';
import logoImage from '../../3 ICON.png';

/**
 * Header component that displays the Rithmo logo and tagline.
 *
 * @returns {JSX.Element} The header with logo
 */
function Header() {
  return (
    <div className="header">
      <div className="header-content">
        <div className="logo-container">
          <img src={logoImage} alt="Rithmo logo" className="logo-image" />
        </div>
        <h1>Rithmo AI</h1>
        <p className="tagline">The AI Teammate for Organizational Intelligence</p>
      </div>
    </div>
  );
}

export default Header;